import React, { Component } from 'react';

import { InputBlock, InputBlockIcon } from 'components/input';
import { I18n } from 'components/translate';
import { formatBytes } from 'helpers/File';
import { FileService } from 'modules/file';
import {
  BoxImageUpload,
  BoxMultipleImagesUpload
} from 'modules/file/components';
import PropTypes from 'prop-types';

import { UploadManager } from '@hotmart/club-files-ui';

import './ImageUploadGroup.scss';

class ImageUploadGroup extends Component {
  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    images: PropTypes.array,
    entity: PropTypes.string,
    icon: PropTypes.string,
    labelValue: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholderImg: PropTypes.func,
    setMediaUrl: PropTypes.func,
    maxFileSize: PropTypes.number,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    multiple: PropTypes.bool
  };

  static defaultProps = {
    images: [],
    multiple: false
  };

  getImportPath(basePath, Component) {
    return `${basePath}/${Component}`;
  }

  get value() {
    const { images, multiple } = this.props;

    return multiple ? images : images[0];
  }

  render() {
    const {
      description,
      placeholderImg,
      onChange,
      multiple,
      maxFileSize,
      maxWidth,
      maxHeight,
      entity,
      icon,
      ...props
    } = this.props;

    const InputBlockComponent = icon ? InputBlockIcon : InputBlock;
    const BoxUploadComponent = multiple
      ? BoxMultipleImagesUpload
      : BoxImageUpload;

    return (
      <InputBlockComponent name={name} {...props}>
        <div className="image__upload__wrapper">
          <BoxUploadComponent
            {...props}
            name={name}
            value={this.value}
            onChange={onChange}
            entityType={entity}
            placeholderImg={placeholderImg}
          />

          {description && (
            <div className="image__upload__description">
              <I18n
                html
                className="secondary"
                label={description}
                data={{ size: formatBytes(maxFileSize), maxWidth, maxHeight }}
              />
            </div>
          )}
        </div>
      </InputBlockComponent>
    );
  }
}

export default (props) => (
  <UploadManager
    {...props}
    onError={FileService.handleFileException}
    itemsProp="images"
  >
    <ImageUploadGroup />
  </UploadManager>
);
